const cache = {};
const norm = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
const fileKey = (src) => norm((src || '').split('/').pop().split('?')[0].replace(/\.[a-z]+$/i, '').replace(/_[0-9a-f]{8}-[0-9a-f-]{27,}$/i, ''));
const tokens = (v) => (v || '').toLowerCase().split(/[^a-z0-9]+/).filter((t) => t.length >= 3);
const near = (key, t) => {
  for (let i = 0; i + t.length <= key.length; i++) {
    let diff = 0;
    for (let j = 0; j < t.length && diff < 2; j++) if (key[i + j] !== t[j]) diff++;
    if (diff < 2) return true;
  }
  return false;
};
const SIZE = /size|length|qty|quantity|pack|amount|volume|weight|rate|value|engrav|personal/i;

const load = (handle) => {
  cache[handle] ||= fetch(`/products/${handle}.js`).then((r) => r.json()).then((p) => {
    p.aptsMedia = (p.media || []).filter((m) => m.media_type === 'image').map((m) => {
      const key = fileKey(m.src) + '|' + norm(m.alt);
      return { id: m.id, src: m.src, key, flat: /fabric|swatch/.test(key) };
    });
    return p;
  });
  return cache[handle];
};

const match = (media, values) => {
  const toks = values.flatMap(tokens);
  if (!toks.length) return null;
  let best = null;
  for (const m of media) {
    let exact = 0;
    const ok = toks.every((t) => {
      if (m.key.includes(t)) return ++exact;
      if (t.length > 3 && m.key.includes(t.slice(0, 3))) return true;
      return t.length >= 5 && near(m.key, t);
    });
    if (!ok) continue;
    const score = exact * 100 - m.key.length + (m.flat ? 0 : 50);
    if (!best || score > best.score) best = { m, score, tie: false };
    else if (score === best.score) best.tie = true;
  }
  return best && !best.tie ? best.m : null;
};

const designFieldsets = (picker, product) =>
  [...picker.querySelectorAll('fieldset.variant-option')].filter((f) => {
    const name = f.querySelector('input')?.dataset.optionName || '';
    return !SIZE.test(name) && product.options.some((o) => (o.name || o) === name);
  });

const gallery = (picker) => {
  const scope = picker.closest('.quick-add-modal__content, product-component, .product-information, .shopify-section') || document;
  return scope.querySelector('media-gallery slideshow-component');
};

const show = async (picker) => {
  const handle = picker.dataset.productHandle;
  if (!handle || document.querySelector(`[data-apts-gv][data-product-id="${picker.dataset.productId}"]`)) return;
  const product = await load(handle);
  if (!product.aptsMedia.length) return;
  const sets = designFieldsets(picker, product);
  if (!sets.length) return;

  sets.forEach((set) => {
    if (set.querySelector('.apts-vchip__img, .swatch')) return;
    const labels = [...set.querySelectorAll('label.variant-option__button-label')];
    const hits = labels.map((l) => match(product.aptsMedia, [l.querySelector('input')?.value]));
    const found = hits.filter(Boolean);
    if (found.length < labels.length * 0.8 || new Set(found.map((h) => h.id)).size !== found.length) return;
    labels.forEach((l, i) => {
      if (!hits[i]) return;
      l.classList.add('apts-vchip');
      const span = document.createElement('span');
      span.className = 'apts-vchip__img';
      span.innerHTML = `<img src="${hits[i].src}${hits[i].src.includes('?') ? '&' : '?'}width=120" width="60" height="60" loading="lazy" alt="">`;
      l.querySelector('.variant-option__button-label__text')?.before(span);
    });
  });

  const variantId = Number(picker.querySelector('input:checked[data-variant-id]')?.dataset.variantId);
  const variant = product.variants.find((v) => v.id === variantId);
  if (variant?.featured_media) return;
  const values = sets.map((s) => s.querySelector('input:checked')?.value).filter(Boolean);
  const hit = match(product.aptsMedia, values);
  if (!hit || picker.dataset.aptsShown === `${variantId}`) return;
  const slider = gallery(picker);
  const slides = [...(slider?.querySelectorAll('slideshow-slide') || [])];
  const index = slides.findIndex((s) => s.querySelector(`[data-media-id="${hit.id}"]`));
  if (index < 0) return;
  picker.dataset.aptsShown = `${variantId}`;
  slider.select?.(index, undefined, { animate: true });
};

let queued = false;
const run = () => {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    document.querySelectorAll('variant-picker').forEach((p) => show(p).catch(() => {}));
  });
};

document.addEventListener('change', (e) => {
  const picker = e.target.closest?.('variant-picker');
  if (!picker) return;
  delete picker.dataset.aptsShown;
  setTimeout(run, 350);
});
new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
run();
